import type { Translatable } from "app/pages/sales-intelligence/types";

export const TOOLTIP_I18N_KEYS: Record<"innerTableKey" | "companyKey" | "websiteKey", string> = {
    innerTableKey: "si.assign-to-user.company.button.tooltip.inner-table",
    companyKey: "si.assign-to-user.company.button.tooltip",
    websiteKey: "si.multi_selector.tooltip.assign",
};

export const WEBSITE_ASSIGN_TO_USER_MODAL_TITLE: Translatable = { key: "si.assigned-to-user-modal.title" };

export const COMPANY_ASSIGN_TO_USER_MODAL_TITLE: Translatable = { key: "si.assigned-to-user-modal.company.title" };
